export const isDefaultUrl = () => {
  return window.location.hostname.replace(/^www\.(?=[^.]*\.)/i, '') === process.env.NEXT_PUBLIC_MARKETPLACE_BASE_URL;
};
